import { Component, OnInit, Input, HostBinding } from '@angular/core';
import { SessionService } from '../../../core/services/session.service';
import { Icon } from '../../models/icon';

@Component({
  selector: 'app-icon',
  templateUrl: './icon.component.html',
  styleUrls: ['./icon.component.scss']
})
export class IconComponent implements OnInit {
  @Input() icon: Icon;
  @Input() cssClass: string;
  @Input() addHoverClass = true;
  classList: string;
  hoverClass = 'icon-hover';
  @HostBinding('class') iconClass = 'sil-icon';

  constructor(private readonly session: SessionService) { }

  ngOnInit(): void {
    const prefix = this.session.getContextPrefix() === 'sil' ? 'silicon' : 'uppicon';
    const defaultClass = 'glyphicon-' + prefix + '-' + this.icon;
    this.classList = this.addHoverClass ? (this.hoverClass + ' ' + defaultClass) : defaultClass ;

    if (this.cssClass) {
      this.classList += ' ' + this.cssClass;
    }
  }
}
